export const GOOGLE_SCRIPT_ID = 'google-maps-js-api-script';
export const GOOGLE_API_ORIGIN = 'https://maps.googleapis.com';
export const GOOGLE_API_LIBRARIES = ['geometry', 'drawing', 'places', 'marker'];
export const GOOGLE_API_LANGUAGE = 'en';
export const GOOGLE_API_REGION = 'GB';
export const GOOGLE_API_MAP_ZOOM_DEFAULT = 6;
export const GOOGLE_API_MAP_ZOOM_MAX = 18;
